export default __webpack_public_path__ + "static/blob9-4b156399ffff5d2269ab53336ad94e97.svg";